export enum RealtimeActions {
    SESSION_SYN = "SYN",
    SESSION_ACK = "ACK" ,
    SESSION_SYN_ACK = "SYN_ACK"    
}